import { createSlice } from '@reduxjs/toolkit';

import * as reducers from 'store/reducers/pageLayoutReducer';
import { IPageLayoutState } from 'store/types/pageLayoutTypes';

const initialState: IPageLayoutState = {
  isAudioPlaying: true,
  isAudioControlVisible: true,
  isHeaderVisible: true,
  isFooterVisible: true,
  audioSource: '',
  isInApp: false,
  isMenuVisible: false,
  currentTheme: null,
};

export const pageLayoutSlice = createSlice({
  name: 'pageLayout',
  initialState,
  reducers,
});

export const {
  setIsHeaderVisible,
  setIsFooterVisible,
  setIsMenuVisible,
  setMultipleLayoutOptions,
  setAudioSource,
  stopAndHideAudio,
  setToggleCurrentTheme,
} = pageLayoutSlice.actions;
export default pageLayoutSlice.reducer;
